/* basic. production runtime adapter */
const boiseThumbs = [...document.querySelectorAll('.pdp-thumb')];
boiseThumbs.forEach(thumb => {
  if (!thumb.dataset.src) thumb.dataset.src = thumb.dataset.gallerySrc || '';
  if (!thumb.dataset.alt) thumb.dataset.alt = thumb.dataset.galleryAlt || '';
});
const boisePhoto = document.querySelector('#pdp-main-photo, #catalog-main-image');
let boisePhotoIndex = 0;

function showBoisePhoto(index) {
  if (!boisePhoto || !boiseThumbs.length) return;
  const nextIndex = (index + boiseThumbs.length) % boiseThumbs.length;
  if (nextIndex === boisePhotoIndex) return;
  const next = boiseThumbs[nextIndex];
  boisePhotoIndex = nextIndex;
  (window.BasicProductImages ? window.BasicProductImages.setImage(boisePhoto, next.dataset.src) : (boisePhoto.removeAttribute('srcset'), boisePhoto.src = next.dataset.src));
  boisePhoto.alt = next.dataset.alt;
  boiseThumbs.forEach((thumb, i) => {
    const active = i === nextIndex;
    thumb.classList.toggle('is-active', active);
    thumb.setAttribute('aria-pressed', String(active));
  });
}
boiseThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showBoisePhoto(index)));
document.querySelector('#pdp-photo-prev, [data-gallery-prev]')?.addEventListener('click', () => showBoisePhoto(boisePhotoIndex - 1));
document.querySelector('#pdp-photo-next, [data-gallery-next]')?.addEventListener('click', () => showBoisePhoto(boisePhotoIndex + 1));

let boiseTouchX = null;
const boiseMainImage = document.querySelector('#pdp-main-image, .pdp-gallery .pdp-main-image');
boiseMainImage?.addEventListener('touchstart', event => { boiseTouchX = event.changedTouches[0].screenX; }, {passive:true});
boiseMainImage?.addEventListener('touchend', event => {
  if (boiseTouchX === null) return;
  const difference = event.changedTouches[0].screenX - boiseTouchX;
  if (Math.abs(difference) > 45) showBoisePhoto(boisePhotoIndex + (difference < 0 ? 1 : -1));
  boiseTouchX = null;
}, {passive:true});

const boiseOffers = [...document.querySelectorAll('input[name="boise-offer"]')];
const boiseQuantityInput = document.querySelector('#boise-quantity-input');
const boiseForm = document.querySelector('#boise-cart-form');
const boisePrices = {1:10,3:27,6:50};
function boiseMoney(amount) { return `CHF ${amount}.–`; }

function updateBoisePurchase() {
  const selected = boiseOffers.find(option => option.checked);
  const quantity = Number(selected.value);
  const total = boisePrices[quantity];
  const countLabel = `${quantity} ${quantity === 1 ? 'recharge' : 'recharges'}`;
  boiseOffers.forEach(option => option.closest('.classik-offer').classList.toggle('is-selected', option === selected));
  boiseQuantityInput.value = String(quantity);
  boiseQuantityInput.setAttribute('value', String(quantity));
  [3, 6].forEach(count => {
    document.querySelector('#boise-offer-price-' + count).textContent = boiseMoney(boisePrices[count]);
    document.querySelector('#boise-offer-compare-' + count).textContent = boiseMoney(boisePrices[1] * count);
    document.querySelector('#boise-offer-savings-' + count).textContent = 'Économie ' + boiseMoney(boisePrices[1] * count - boisePrices[count]);
  });
  document.querySelector('#boise-selection-summary').textContent = `${countLabel} Le Boisé${quantity === 6 ? ' · 5 payées, 1 offerte' : ''}`;
  document.querySelector('#boise-selection-price').textContent = boiseMoney(total);
  const saving = boisePrices[1] * quantity - total;
  const savingMessage = document.querySelector('#boise-selection-saving');
  savingMessage.hidden = saving === 0;
  savingMessage.textContent = saving ? `Tu économises ${boiseMoney(saving)} sur les produits, par rapport à ${boiseMoney(boisePrices[1] * quantity)} pour ${quantity} recharges à l’unité (hors livraison).` : '';
  document.querySelector('#boise-add-label').textContent = quantity === 1 ? 'Ajouter ma recharge' : 'Ajouter mes recharges';
  document.querySelector('#boise-total').textContent = boiseMoney(total);
  document.querySelector('#boise-sticky-count').textContent = countLabel;
  document.querySelector('#boise-sticky-price').textContent = boiseMoney(total);
}
boiseOffers.forEach(option => option.addEventListener('change', updateBoisePurchase));
boiseForm.addEventListener('submit', updateBoisePurchase);
updateBoisePurchase();

const boiseSticky = document.querySelector('#pdp-mobile-buy');
const boiseClosing = document.querySelector('.pdp-closing');
function updateBoiseSticky() {
  const passedBuyBox = boiseForm.getBoundingClientRect().bottom < 82;
  const nearEnd = boiseClosing.getBoundingClientRect().top < window.innerHeight * .82;
  const visible = window.innerWidth <= 700 && passedBuyBox && !nearEnd && !document.body.classList.contains('menu-locked');
  boiseSticky.classList.toggle('is-visible', visible);
  boiseSticky.setAttribute('aria-hidden', String(!visible));
  boiseSticky.inert = !visible;
}
window.addEventListener('scroll', updateBoiseSticky, {passive:true});
window.addEventListener('resize', updateBoiseSticky);
new MutationObserver(updateBoiseSticky).observe(document.body, {attributes:true,attributeFilter:['class']});
updateBoiseSticky();
